import { v4 as uuidv4 } from "uuid"; // Make sure to install and import the uuid package
import "./css/App.css";

export const createSafeURL = (text) => {
  // Replace spaces with hyphens and remove special characters
  const sanitizedText = text
    .toString()
    .toLowerCase() // convert to lowercase for uniformity in URLs
    .trim()
    .replace(/[^a-z0-9\s-]/g, "") // remove all non-alphanumeric characters except spaces and hyphens
    .replace(/\s+/g, "-") // replace spaces with hyphens
    .replace(/-+/g, "-"); // replace multiple hyphens with a single one

  const uniqueID = uuidv4().slice(0, 8); // Generate UUID and take first 8 characters
  return `${sanitizedText}-${uniqueID}`;
};

export const showNotification = (message, messageState, duration = 3000) => {
  const notification = document.createElement("div");

  // Set base class
  if (messageState === "error") {
    notification.className = "notification-error";
  } else if (messageState === "info") {
    notification.className = "notification-info";
  } else {
    notification.className = "notification";
  }

  // Set message text
  notification.innerText = message;

  // Positioning (100px from top)
  notification.style.position = "fixed";
  notification.style.top = "10%";
  notification.style.left = "50%";
  notification.style.transform = "translateX(-50%)";
  notification.style.zIndex = 9999;

  document.body.appendChild(notification);

  // Show the notification
  setTimeout(() => {
    notification.classList.add("show");
  }, 100);

  // Hide the notification after the specified duration
  setTimeout(() => {
    notification.classList.remove("show");
    setTimeout(() => {
      document.body.removeChild(notification);
    }, 500);
  }, duration);
};

export const formatPeriodDisplay = (from, to) => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const format = (val) => {
    if (!val || val.length !== 6) return "";
    const mm = parseInt(val.slice(0, 2), 10) - 1;
    const yyyy = val.slice(2);
    return `${monthNames[mm]}, ${yyyy}`;
  };

  const fromStr = format(from);
  const toStr = to ? format(to) : "On-going";

  return `${fromStr} to ${toStr}`;
};
